import { RootState } from 'global/state';

export const getLoggedInStatus = (state: RootState) => state.loginState.username !== '';
export const getUsername = (state: RootState) => state.loginState.username;
export const getAvatarUrl = (state: RootState) => state.loginState.avatarUrl;
export const getUserFullName = (state: RootState) => state.loginState.name;
export const getUserPermissions = (state: RootState) => state.loginState.permissions;
export const getLoginCookieAcceptance = (state: RootState) => state.loginState.acceptedCookieAgreement;
export const getLoginErrorStatus = (state: RootState) => state.loginState.loginErrorMessage;
